import React from 'react'
import bemAquiLogo from '../assets/bemAquiLogo.png'
import headerIcon from '../assets/headerIcon.png'
import greyCurves from '../assets/greyCurves.png'
import { Button, Grid, Typography } from '@material-ui/core'
import { styles } from '../styles/js/header'
import { withStyles } from '@material-ui/core'

const HeaderComponent = ({
  classes,
  title,
  description,
  description2,
  setDialogRecommendation,
  setDialogBusiness,
}) => {
  return (
    <Grid container className={classes.root} justify='center'>
      <img src={greyCurves} className={classes.greyCurves} />
      <Grid item xs={11} sm={10} lg={9} xl={6}>
        <Grid container>
          <Grid item xs={12} md={6}>
            <Grid item xs={12} style={{ zIndex: 999 }}>
              <img src={bemAquiLogo} className={classes.bemAquiLogo} />
            </Grid>
            <Grid item xs={12} style={{ zIndex: 999 }}>
              <Typography variant='h1' className={classes.title}>
                {title}
              </Typography>
            </Grid>

            <Grid item xs={12} style={{ zIndex: 999 }}>
              <Typography variant='h5' className={classes.description}>
                {description}
              </Typography>
              <Typography variant='h6' className={classes.secondDescription}>
                {description2}
              </Typography>
            </Grid>

            <Grid container spacing={1}>
              <Grid item xs={5}>
                <Button
                  variant='contained'
                  color='secondary'
                  size='large'
                  className={`${classes.formButton} ${classes.indicar}`}
                  classes={{ label: classes.formButtonLabel }}
                  onClick={() =>
                    setDialogRecommendation({ isOpen: true, data: null })
                  }
                >
                  Quero Indicar
                </Button>
              </Grid>

              <Grid item xs={7}>
                <Button
                  variant='outlined'
                  color='secondary'
                  size='large'
                  className={`${classes.formButton} ${classes.cadastrar}`}
                  classes={{ label: classes.formButtonLabel }}
                  onClick={() =>
                    setDialogBusiness({ isOpen: true, data: null })
                  }
                >
                  Cadastrar Minha Empresa
                </Button>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={6}>
            <img src={headerIcon} className={classes.headerIcon} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(HeaderComponent)
